const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AuthQuery: any = {
    Logout: Backofficebff + '/v1/auth/logout',
};
